// extracted by mini-css-extract-plugin
module.exports = {"upload":"AttachmentButton_upload__2NX-k","addFileButton":"AttachmentButton_addFileButton__3nWzo","buttonText":"AttachmentButton_buttonText__1RuQ4"};